export default __webpack_public_path__ + "static/media/MAI_Rose.d1503131.png";